import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { proxyBasePath } from '@app/core/config/url-paths.config';
import { PortalApiService } from '@app/shared/services/portal-api.service';
import { environment } from '@environments/environment';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'estimated-delivery-weeks',
    imports: [],
    templateUrl: './estimated-delivery-weeks.component.html',
    styleUrl: './estimated-delivery-weeks.component.scss'
})
export class EstimatedDeliveryWeeksComponent implements OnInit {

    readonly #destroyRef = inject(DestroyRef)
    #portalApiService = inject(PortalApiService)
    #modalService = inject(BsModalService)

    @Input() modalId: string = ''

    estimatedDlvWeeks = []
    errorMessage: string = ''

    #lastHeading: string = ''
    #year = '' + new Date().getFullYear()
    currentYear: string

    ngOnInit(): void {
        this.currentYear = this.#year.substring(2, 4)

        this.getEstimatedDlvWeeks()
    }

    isNewHeading(heading: string) {

        // Compare with previous
        const headingIsNew: boolean = heading != this.#lastHeading;

        // Set previous compared
        this.#lastHeading = heading

        return headingIsNew;
    }

    formatWeek(week: number, weekDay: string) {
        if (weekDay != undefined && weekDay != '') {
            return week + '/' + weekDay;
        }

        return week;
    }

    downloadPDF() {

        this.#portalApiService.getEstimatedDeliveryWeeksPdfHash()
            .pipe(takeUntilDestroyed(this.#destroyRef)).subscribe({
                next: (response) => {
                    // Dataservice delivers a HashId that we use to access the PDF with.
                    // HashId is valid for 10 minutes, then it will be removed upon next openPDF by the AxApi.

                    const hashId = response
                    const pdfURL: string = proxyBasePath() + environment.axApiProxyPath_ResolveHashedUri + '/Preliminära Leveransveckor ' + new Date().toLocaleDateString('sv-SE') + '?id=' + hashId;

                    window.open(pdfURL);
                }
            })
    }

    private getEstimatedDlvWeeks() {
        this.errorMessage = undefined;

        this.#portalApiService.getEstimatedDeliveryWeeks()
            .pipe(takeUntilDestroyed(this.#destroyRef)).subscribe({
                next: (response) => this.estimatedDlvWeeks = response,
                error: () => {
                    this.estimatedDlvWeeks = [];
                    this.errorMessage = 'Kunde inte hämta preliminära leveransveckor från servern';
                }
            })
    }

    close() {
        this.#modalService.hide(this.modalId)
    }
}
